<template>
  <div class="wonderful-topic">
    <nav class="tip-title __fs-16 _fw-500">精选专题</nav>
    <ul>
      <li v-for="(item, index) in list" :key="index" @click=" cbDetail (item)">
        <van-image class="banner-img" :src="formatAliyunPath(item.src)"/>
        <div class="content">
          <p class="name">{{item.name}}</p>
          <div class="description">{{item.description}}</div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { aliyun } from '@/agent'
export default {
  name: 'WonderfulStory',
  props: {
    list: {
      type: Array,
    }
  },
  data () {
    return {}
  },
  methods: {
    // 点击swiper
    cbDetail (item) {
      this.$router.push({
        path: '/building/detail',
        query: {
          id: item.id,
          type: 'topic',
        }
      })
    },
    // 格式化阿里云地址
    formatAliyunPath (path) {
      return aliyun.getAliyunAddress(path)
    },
  },
}
</script>

<style scoped lang="scss">
.wonderful-topic {
  margin: 36px 20px 0px 20px;
  .tip-title {
    padding-left: 8px;
    border-left: 3px solid $main-color;
    border-radius: 2px;
    color: #282828;
    margin-bottom: 25px;
  }
  ul {
    width: 100%;
    white-space: nowrap;
    overflow-x: auto;
    scrollbar-width: none;
    -ms-overflow-style: none;
    display:-webkit-box;
    &::-webkit-scrollbar {
      display: none;
    }
    li {
      display: block;
      width: 240px;
      white-space: pre-wrap;
      &:not(:last-child) {
        margin-right: 15px;
      }
      .banner-img {
        width: 100%;
        height: 135px;
        display: block;
      }
      .content {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        .name {
          margin: 20px 0 11px;
          opacity: 1;
          font-size: 17px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #252525;
          line-height: 24px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
        }
        .description{
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #828282;
          line-height: 18px;
          overflow: hidden; // 文字超过三行省略号处理
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
    }
  }
}
</style>
